import { render, staticRenderFns } from "./Coa.vue?vue&type=template&id=c9015704"
import script from "./Coa.vue?vue&type=script&lang=js"
export * from "./Coa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports